import {Injectable} from '@angular/core';
import {Observable} from 'rxjs/Rx';
import {NestApiProvider} from "../../nest-api";
import { ResponseAddDto, ResponseSaveDto, ResponseDeleteDto, ResponseListingDto } from '../dto/serviceagreement.dto';

@Injectable()
export class ServiceagreementSf6Api {

  private readonly service: string = '';
  private readonly model: string = 'sf6s';

  constructor(
    private nestApiProvider: NestApiProvider,
  ) {
  }

  public add(payload: any): Observable<ResponseAddDto> {
    const method: string = 'POST';
    const func: string = 'serviceAgreement/add';
    const params: any = payload || {};
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request<ResponseAddDto>(method, url, params, urlParams, body);
  }

  public save(payload: any): Observable<ResponseSaveDto> {
    const method: string = 'POST';
    const func: string = 'serviceAgreement/save';
    const params: any = payload || {};
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request<ResponseSaveDto>(method, url, params, urlParams, body);
  }

  public delete(payload: any): Observable<ResponseDeleteDto> {
    const method: string = 'POST';
    const func: string = 'serviceAgreement/delete';
    const params: any = payload || {};
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request<ResponseDeleteDto>(method, url, params, urlParams, body);
  }

  public listing(empId: string): Observable<ResponseListingDto> {
    const method: string = 'GET';
    const func: string = 'serviceAgreement/listing';
    const params: any = {};
    const urlParams: any = {};
    const body: any = {};

    if (typeof empId !== 'undefined' && empId !== null) urlParams.empId = empId;

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, params, urlParams, this.service);
    return this.nestApiProvider.request<ResponseListingDto>(method, url, func, params, body);
  }
}



// WEBPACK FOOTER //
// ./src/shared/nestjs/gd-integrated/services/serviceagreement-sf6.api.ts